// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2ytJC","header":"ReportDetails_header__3YbnX","title":"ReportDetails_title__1vUul","left":"ReportDetails_left__2m5zx"};